module.exports = __webpack_public_path__ + "static/media/time.9fd085e5.svg";